import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

export default function ShareButton() {
    const {t} = useTranslation();
    const [state, setState] = useState('ready');
    const [url, setUrl] = useState('');
    async function copyLink() {
        const link = window.location.href;
        try {
            await navigator.clipboard.writeText(link);
            setState('copied');
        } catch {
            setUrl(link);
            setState('fallback');
        }
    }
    return (
        <div className="blog-share">
            <button type="button" className="blog-share-button" onClick={copyLink}>
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    aria-hidden="true"
                >
                    <rect x="8" y="8" width="12" height="12" rx="3" />
                    <path d="M15 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2" />
                </svg>
                <span aria-live="polite">{t(state === 'copied' ? 'blog.linkCopied' : 'blog.share')}</span>
            </button>
            {state === 'fallback' && (
                <label className="blog-share-fallback">
                    {t('blog.copyLink')}
                    <input value={url} readOnly onFocus={(event) => event.target.select()} />
                </label>
            )}
        </div>
    );
}
